<div class="warp-white">
    <div class="grid-header">
        <div class="flex-2 first" translate>column.reminder.subject</div>
        <div class="flex-1" translate>column.reminder.createDate</div>
        <div class="flex-1" translate>column.reminder.dateStart</div>
        <div class="flex-1" translate>column.reminder.hour</div>
        <div class="flex-1" translate>column.reminder.frequently</div>
        <!-- <div class="flex-1" *ngIf="isByFolders"> מיקום</div> -->
        <div class="flex-1" translate>column.reminder.dateEnd</div>
        <!-- <div class="flex-1" translate>column.reminder.user</div> -->
        <!-- <div class="flex-1" translate>column.reminder.isApproval</div> not in amdocs -->
        <div class="flex-2" translate>column.reminder.recipient</div>
        <div class="flex-2" translate>column.reminder.content</div>
        <div class="flex-half last"></div>
    </div>
</div>